var angular = require('angular');
var _module = angular.module('benoit');

require('angular-ui-router');
require('../user');

_module.requires.push('ui.router');

_module.provider('keepAffiliateInUrl', [
    function keepAffiliateInUrlProvider() {
        var ignoreRoutes = [];

        /*
        Addes routes to ignore adding the
        users affiliate code to.

        Params can either be a single arrgument as an array
        or multiple strings as multiple arguments.

        @function addRoutesToIgnore
        */
        this.addRoutesToIgnore = function addRoutesToIgnore() {
            var routes;

            if(angular.isArray(arguments[0])) {
                routes = arguments[0];
            } else {
                routes = Array.prototype.slice.call(arguments);
            }

            ignoreRoutes = ignoreRoutes.concat(routes);
        };

        this.$get = [
            '$location',

            function $get($location) {
                return {
                    getIgnoredRoutes: function getIgnoredRoutes() {
                        return ignoreRoutes;
                    }
                };
            }
        ];
    }
]);

_module.run([
    '$log',
    '$rootScope',
    '$location',
    '$user',
    '$state',
    'keepAffiliateInUrl',

    function run($log, $rootScope, $location, $user, $state, keepAffiliateInUrl) {
        $rootScope.$watch(function () { return $user.affiliate; }, function (value) {
            if(value) {
                checkAffiliate($user);
            }
        }, true);

        $rootScope.$on('$stateChangeSuccess', function onStateChangeSuccess() {
            checkAffiliate($user);
        });

        function checkAffiliate($user) {
            var stateName = $state.current.name;

            if($user && $user.affiliate && $user.affiliate.affiliate_code && !~keepAffiliateInUrl.getIgnoredRoutes().indexOf(stateName)) {
                if(!$location.search().affiliate) {
                    $location.search('affiliate', $user.affiliate.affiliate_code);
                }
            } else {
                $location.search('affiliate', null);
            }
        }
    }
]);
